<template>
    <TheHeader></TheHeader>

    <div class="container-fluid">
        <div class="container">
            <form name="form">
                <div class="contain row">
                    <TheSidebar></TheSidebar>

                    <div class="page-container card col-md-8">
                        <ThePageHeader @delete-event="deleteUser" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>

                        <div class="row" v-if="pageError == ''">
                            <TabView class="p-1">
                                <TabPanel>
                                    <template #header>
                                        <i class="me-1 pi pi-fw pi-file"></i>
                                        <span>Info</span>
                                    </template>

                                    <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>

                                    <div class="row" v-if="!isPageLoading">
                                        <div class="col-md-12 p-4">
                                            <div class="row mb-3">
                                                <div class="col-md-3 required">
                                                    <label class="col-form-label-title">Name:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <InputText class="p-inputtext" type="text" maxlength="50" placeholder="Name" v-model="user.employee.name" :disabled="!isAdmin && userRole == 'Admin'"/>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3 required">
                                                    <label class="col-form-label-title">Email Address:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <InputText class="p-inputtext" type="text" maxlength="50" placeholder="Email Address" v-model="user.employee.emailAddress" :disabled="identifier != null"/>
                                                </div>

												<div class="col-md-3 d-flex align-items-center" v-if="user.failedLoginCount >= 3">
													<i v-tooltip.right="{value: 'Account Locked'}" class="pi pi-lock text-danger"></i>
												</div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3 required">
                                                    <label class="col-form-label-title">Phone Number:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <InputText class="p-inputtext" type="text" maxlength="15" placeholder="Phone Number" v-model="user.employee.mobilePhone" @keypress="filterNonNumeric" :disabled="!isAdmin && userRole == 'Admin'"/>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3 required">
                                                    <label class="col-form-label-title">Role:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <Dropdown :options="filterUserRoles" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="userRole" display="chip" @change="resetCompanies" :disabled="!isAdmin && userRole == 'Admin'"/>
                                                </div>
                                            </div>

                                            <div class="row mb-3" v-if="identifier != null">
                                                <div class="col-md-3 required">
                                                    <label class="col-form-label-title">Status:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="user.isClosed" :disabled="!isAdmin && userRole == 'Admin'"/>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <Divider/>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3" :class="userRole == 'RPK User' ? 'required' : '' ">
                                                    <label class="col-form-label-title">Accessible Company:</label>
                                                </div>

												<div class="col-md-6">
													<MultiSelect :virtualScrollerOptions="{ itemSize: 44 }" :options="companies" optionLabel="code" display="chip" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isCompanyLoading" v-model="selectedCompanies" :disabled="!(userRole == 'RPK User')">
														<template #option="slotProps">
															<div class="d-flex align-items-center col-md-12">
																<span class="col-md-3">{{ slotProps.option.code }}</span>
																<span class="col-md-9">{{ slotProps.option.name }}</span>
															</div>
														</template>
													</MultiSelect>
												</div>
                                                
                                                <div class="col-md-2">
                                                    <Button icon="pi pi-plus" @click="addCompanies" :disabled="selectedCompanies.length == 0 || userRole != 'RPK User'"/>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <DataTable :value="user.employee.employeeCompanies" responsiveLayout="scroll" selectionMode="single">
                                                    <Column style="width: 90%;" field="company.name" header="Accessible Company"></Column>

                                                    <Column style="width: 10%" header="">
                                                        <template #body="slotProps">
															<Button icon="pi pi-trash" severity="danger" text rounded @click="removeCompany(slotProps.index)" title="Remove" />
                                                        </template>
                                                    </Column>

                                                    <template #empty>
                                                        <div class="error-no-record mt-3" v-if="user.employee.employeeCompanies.length <= 0">
                                                            <FontAwesomeIcon :icon="['fas', 'image']" size="2x"/>
                                                            <h6><span>No Record Found</span></h6>
                                                        </div>
                                                    </template>
                                                </DataTable>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3"></div>

                                                <div class="d-flex col-md-6">
                                                    <Button class="p-button-sm" :disabled="v$.user.$invalid || v$.userRole.$invalid || isLoading || (!isAdmin && userRole == 'Admin')" @click="identifier == null ? save() : update()" label="Save"/>
                                                    <span class="p-1"></span>
                                                    <Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>

                                                    <TheLoading v-if="isLoading"></TheLoading>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>

                                <TabPanel v-if="identifier != null && isAdmin">
                                    <template #header>
                                        <i class="me-1 pi pi-fw pi-lock"></i>
                                        <span>Password</span>
                                    </template>

                                    <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>

                                    <div class="row" v-if="!isPageLoading">
                                        <div class="col-md-12 p-4 d-flex">
											<div class="col-md-8 pe-2">
												
												<div class="row mb-3">
													<div class="col-md-5 required">
														<label class="col-form-label-title">New Password:</label>
													</div>
													
													<div class="col-md-7">
														<Password :strongRegex="strongRegex" :class="{'p-invalid': (passwordNotMatch || v$.password.newPassword.strongRegexValidator.$invalid) && password.newPassword != ''}" maxlength="50" placeholder="New Password" toggleMask v-model="password.newPassword"></Password>
													</div>
												</div>
												
												<div class="row mb-3">
													<div class="col-md-5 required">
														<label class="col-form-label-title">Confirm Password:</label>
													</div>
													
													<div class="col-md-7">
														<Password :strongRegex="strongRegex" :class="{'p-invalid': (passwordNotMatch || v$.password.confirmPassword.strongRegexValidator.$invalid) && password.confirmPassword != ''}" maxlength="50" placeholder="Confirm Password" toggleMask v-model="password.confirmPassword"></Password>
													</div>
													
													<div class="col-md-5" v-if="passwordNotMatch"></div>
													
													<small class="col-md-7 p-error" v-if="passwordNotMatch">Passwords do not matched.</small>
												</div>
											</div>

											<div class="col-md-4 ps-2">
												<div class="col-md-12">
													<div class="row">
														<div class="col-md-12">
															<label class="col-form-password-policy-title">Password Policy:</label>
															<ul class="pl-2 ml-2 mt-0 col-form-password-policy">
																<li v-for="policies in passwordPolicy" :key="policies">{{ policies }}</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
										
										<div class="row mb-3">
											<div class="col-md-3"></div>
		
											<div class="d-flex col-md-6">
												<Button class="p-button-sm" :disabled="v$.password.$invalid || isLoading" @click="updatePassword" label="Save"/>
												<span class="p-1"></span>
												<Button class="p-button-sm p-button-warning" @click="resetPassword()" label="Reset Password" :disabled="user.isClosed" v-if="identifier != null"/>
												<span class="p-1" v-if="identifier != null"></span>
												<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
		
												<TheLoading v-if="isLoading"></TheLoading>
											</div>
										</div>
                                    </div>

									
                                </TabPanel>
								
                                <TabPanel v-if="isRoot">
                                    <template #header>
                                        <i class="me-1 pi pi-fw pi-shield"></i>
                                        <span>2FA</span>
                                    </template>

                                    <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>


                                    <div class="row" v-if="!isPageLoading">
                                        <div class="col-md-12 p-4">
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="col-form-label-title">Last Login:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="col-form-label-text">{{ (ciscoDuo2FA.lastLogin == null ? "-" : ciscoDuo2FA.lastLogin) }}</label>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="col-form-label-title">Device Model:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="col-form-label-text">{{ (ciscoDuo2FA.deviceModel == null ? "-" : ciscoDuo2FA.deviceModel) }}</label>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="col-form-label-title">Device Platform:</label>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="col-form-label-text">{{ (ciscoDuo2FA.devicePlatform == null ? "-" : ciscoDuo2FA.devicePlatform) }}</label>
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3"></div>

                                                <div class="d-flex col-md-6">
                                                    <Button class="p-button-sm p-button-warning" :disabled="isLoading || (ciscoDuo2FA.deviceModel == null && ciscoDuo2FA.devicePlatform == null)" @click="reset2FA" label="Reset"/>
                                                    <TheLoading v-if="isLoading"></TheLoading>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>

								<TabPanel :disabled="userRole == 'RPK User'">
                                    <template #header>
                                        <i class="me-1 pi pi-envelope"></i>
                                        <span>Email Controller</span>
                                    </template>

                                    <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>


                                    <div class="row" v-if="!isPageLoading">
                                        <div class="col-md-12 p-4">
                                            <div class="row mb-3">
												<div class="col-md-3">
                                                    <label class="col-form-label-title">Company:</label>
                                                </div>

												<div class="col-md-6">
													<MultiSelect :virtualScrollerOptions="{ itemSize : 44 }" :options="companies" optionLabel="code" display="chip" filter :filterFields="['code', 'name']" showClear :placeholder="isEmailCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isEmailCompanyLoading" v-model="selectedEmailCompanies" :disabled="!isAdmin && userRole == 'Admin'">
														<template #option="slotProps">
															<div class="d-flex align-items-center col-md-12">
																<span class="col-md-3">{{ slotProps.option.code }}</span>
																<span class="col-md-9">{{ slotProps.option.name }}</span>
															</div>
														</template>
													</MultiSelect>
												</div>
                                                
                                                <div class="col-md-2">
													<Button icon="pi pi-plus" @click="addEmailCompanies()" :disabled="selectedEmailCompanies.length == 0 || (!isAdmin && userRole == 'Admin')" />
                                                </div>
                                            </div>

                                            <div class="row mb-3">
                                                <DataTable :value="user.employee.employeeEmailCompanies" responsiveLayout="scroll" selectionMode="single">
                                                    <Column style="width: 90%;" field="emailCompany.name" header="Company:"></Column>

                                                    <Column v-if="isAdmin || userRole != 'Admin'" style="width: 10%" header="">
                                                        <template #body="slotProps">
															<Button icon="pi pi-trash" severity="danger" text rounded @click="removeEmailCompany(slotProps.index)" title="Remove"/>
                                                        </template>
                                                    </Column>

                                                    <template #empty>
                                                        <div class="error-no-record mt-3" v-if="user.employee.employeeEmailCompanies.length <= 0">
                                                            <FontAwesomeIcon :icon="['fas', 'image']" size="2x"/>
                                                            <h6><span>No Record Found</span></h6>
                                                        </div>
                                                    </template>
                                                </DataTable>
                                            </div>

                                            <div class="row mb-3">
                                                <div class="col-md-3"></div>

                                                <div class="d-flex col-md-6">
													<Button class="p-button-sm" :disabled="v$.user.$invalid || v$.userRole.$invalid || isLoading || (!isAdmin && userRole == 'Admin')" @click="identifier == null ? save() : update()" label="Save"/>
                                                    <span class="p-1"></span>
                                                    <Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>

                                                    <TheLoading v-if="isLoading"></TheLoading>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </TabPanel>
                            </TabView>
                        </div>

                        <ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
                    </div>

                    <TheFooter></TheFooter>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts">
	import {defineComponent} from "vue";
	import {useRoute} from "vue-router"
	import store from "@/store";
	import userApi from "@/api/user-api";
	import companyApi from "@/api/company-api"
	import statusMixin from "@/mixin/status";
	import roleMixin from "@/mixin/role";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import passwordUtilsMixin, { strongRegexValidator } from "@/mixin/utils/password-utils";
	import numericUtilsMixin from "@/mixin/utils/numeric-utils";
	
	import {Md5} from "ts-md5";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import {required, requiredIf, email} from "@vuelidate/validators"
	import MultiSelect from "primevue/multiselect";
	
	export default defineComponent({
		mixins: [statusMixin, roleMixin, dateUtilsMixin, passwordUtilsMixin, numericUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTabViewLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				user: {username: '', password: '', employee: {identifier: '', name: '', emailAddress: '', mobilePhone: '', employeeCompanies: [] as any[], employeeEmailCompanies: [] as any[], isClosed: false}, userRoles: [] as any[], isClosed: false},
				ciscoDuo2FA: {lastLogin: null, deviceModel: null, devicePlatform: null},
				companies: [] as any[],
				userRole: null as any,
				selectedCompanies: [] as any[],
				isPageLoading: false,
				isLoading: false,
				isCompanyLoading: false,
				isDeleting: false,
				password: {newPassword: '', confirmPassword: ''},
				passwordNotMatch: false,
				isEmailCompanyLoading: false, 
				selectedEmailCompanies: [] as any[],
			}
		},
		watch: {
			filterLegalGroupId(newValue: any) {
				if (newValue != null) {
					this.user.employee.employeeCompanies = [] as any[];	
				}
				
				this.selectedCompanies = [] as any[];
				this.isCompanyLoading = true;
				companyApi.companyList({}, newValue)
					.then(response => {
						this.companies = response.data.listSet;
						this.isCompanyLoading = false;
					})
					.catch(error => {
						this.isCompanyLoading = false;
					});
			}
		},
		computed: {
			filterLegalGroupId() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			},
			filterUserRoles() {
				if (this.isHQStaff && this.identifier == null) {
					this.roles.forEach((role: any, index: any) => {
						if (role.value == 'Admin') {
							this.roles.splice(index, 1);
						}
					})
					return this.roles;
				}
				return this.roles;
			},
		},
		mounted: function () {
			if (this.pageError == '') {
				this.isPageLoading = true;
	
				let r1 = companyApi.companyList({}, this.filterLegalGroupId);
	
				let r2 = null;
				if (this.identifier != null) {
					r2 = userApi.userView(this.identifier)
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
	
				Promise.all([r1, r2])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.companies = values[i].data.listSet;
											}
											
											else if (i == 1) {
												this.user = values[i].data.user;
												this.ciscoDuo2FA = values[i].data.ciscoDuo2FA;
												
												if (this.user.userRoles != null && this.user.userRoles.length == 1) {
													this.userRole = this.user.userRoles[0].role;
												}
											}
										}
									}
								}
							}
						}
						this.isPageLoading = false;
					})
					.catch(error => {
						this.pageError = error;
						this.isPageLoading = false;
					})
			}
		},
		methods: {
			save() {
				this.isLoading = true;
	
				this.user.username = this.user.employee.emailAddress;
	
				this.user.userRoles = [];
				this.user.userRoles.push({role: this.userRole});
	
				userApi.userSave({
						user: this.user
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/user");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
	
				this.user.userRoles = [];
				
				this.user.userRoles.push({role: this.userRole});
	
				this.user.employee.isClosed = this.user.isClosed;
	
				userApi.userUpdate({
						user: this.user
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/user");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			resetPassword() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to proceed?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						userApi.userResetPassword({
								user: {
									identifier: this.identifier,
								}
							})
							.then((response: any) => {
								this.isLoading = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				});
			},
			updatePassword() {
				this.passwordNotMatch = false;
				if (this.password.newPassword == this.password.confirmPassword) {
					this.isLoading = true;
					userApi.userUpdatePassword({
							user: {
								identifier: this.identifier,
							},
							newPassword: Md5.hashStr(this.password.newPassword)
						})
						.then((response: any) => {
							this.password = {newPassword: '', confirmPassword: ''};
							this.isLoading = false;
							this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						})
						.catch(error => {
							this.isLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
				}
				
				else {
					this.passwordNotMatch = true;
				}
			},
			deleteUser() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this user?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						userApi.userDelete({
								user: this.user
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/user");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/user");
			},
			addCompanies() {
				if (this.selectedCompanies != null && this.selectedCompanies.length > 0) {
					for (let i = 0; i < this.selectedCompanies.length; i++) {
						if (!this.user.employee.employeeCompanies.find(c => c.company.identifier == this.selectedCompanies[i].identifier)) {
							this.user.employee.employeeCompanies.push({company: this.selectedCompanies[i]});
						}
					}
				}
				this.selectedCompanies = [] as any[];
			},
			removeCompany(index: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to remove this company?',
					icon: 'pi pi-trash',
					accept: () => {
						this.user.employee.employeeCompanies.splice(index, 1);
					}
				});
			},
			resetCompanies() {
				if (this.userRole != 'RPK User') {
					this.user.employee.employeeCompanies = [];
				}
				this.selectedCompanies = [] as any[];
			},
			addEmailCompanies() {
				if (this.selectedEmailCompanies != null && this.selectedEmailCompanies.length > 0) {
					for (let i = 0; i < this.selectedEmailCompanies.length; i++) {
						if (!this.user.employee.employeeEmailCompanies.find(c => c.emailCompany.identifier == this.selectedEmailCompanies[i].identifier)) {
							this.user.employee.employeeEmailCompanies.push({emailCompany: this.selectedEmailCompanies[i]});
						}
					}
				}
				this.selectedEmailCompanies = [] as any[];
			},
			removeEmailCompany(index: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to remove this company?',
					icon: 'pi pi-trash',
					accept: () => {
						this.user.employee.employeeEmailCompanies.splice(index, 1);
					}
				});
			},
			reset2FA() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to reset 2FA? User is required to re-enroll to Cisco Duo after reset.',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						userApi.userReset2FA({user: {identifier: this.identifier}})
							.then((response: any) => {
								this.isLoading = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.userView();
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				});
			},
			userView() {
				userApi.userView(this.identifier)
					.then((response: any) => {
						if (response.success) {
							if (response.data != null) {
								this.user = response.data.user
								this.ciscoDuo2FA = response.data.ciscoDuo2FA;
								
								if (this.user.userRoles != null && this.user.userRoles.length == 1) {
									this.userRole = this.user.userRoles[0].role;
								}
							}
						}
					})
					.catch((error) => {
						this.pageError = error;
						this.isPageLoading = false;
					})
			},
		},
		setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				user: {
					employee: {
						name: {
							required
						},
						emailAddress: {
							required, email
						},
						mobilePhone: {
							required
						},
						employeeCompanies: {
							required: requiredIf(this.userRole == 'RPK User')
						},
						isClosed: {
							required
						},
					},
				},
				userRole: {
						required
				},
				password: {
					newPassword: {
						required, strongRegexValidator
					},
					confirmPassword: {
						required, strongRegexValidator
					}
				}
			}
		},
	});
</script>
